import { RouteLocationNormalizedLoadedGeneric } from "vue-router"

/**
 * localStorage 存入和获取
 * set存入数据
 * ex: 存入字符串 local.set('name': 'epan') / 存入对象local.set('sex': { a: boy, b: gril })
 * get获取数据
 * ex: local.get('name')
 * clear清除全部数据
 * ex: local.clear()
 * remove删除数据
 * ex: local.remove('name')
 **/
const local = {
  set(key: string, val?: any) {
    typeof val === 'string'
      ? localStorage.setItem(key, val)
      : localStorage.setItem(key, JSON.stringify(val))
  },
  get(key: string) {
    const val = localStorage.getItem(key)
    if (val) {
      const flag = val.startsWith('{') || val.startsWith('[')
      if (!flag) {
        return val
      } else {
        return JSON.parse(val)
      }
    }
  },
  clear() {
    localStorage.clear()
  },
  remove(key: string) {
    localStorage.removeItem(key)
  },
}

// 重定向URL
const redirect = (systemId: string | number) => {
 window.location.href = `/web/login?extraWeb=1&systemId=${systemId}&redirect=${window.location.pathname}${encodeURIComponent(window.location.search)}`
}

let apiHost = ''
const currentEnv = import.meta.env.MODE;
if (['uat','production','test','dev'].includes(currentEnv)) {
  apiHost = window.location.origin+'/apirouter';
}else {
   apiHost = 'http://localhost:9537/apirouter';
  // apiHost = 'http://localhost:5000';
}

/**
 * 对象深拷贝
 * @param data - 要拷贝的对象
 * @returns 拷贝后的对象
 */
const deepClone = (data: any) => {
  const type = getObjType(data)
  let obj: any
  if (type === 'array') {
    obj = []
  } else if (type === 'object') {
    obj = {}
  } else {
    // 不再具有下一层次
    return data
  }
  if (type === 'array') {
    for (let i = 0, len = data.length; i < len; i++) {
      (obj as any[]).push(deepClone(data[i]))
    }
  } else if (type === 'object') {
    for (const key in data) {
      (obj as { [key: string]: any })[key] = deepClone(data[key])
    }
  }
  return obj
}

/**
 * 获取对象类型
 * @param obj - 要获取类型的对象
 * @returns 对象的类型字符串
 */
const getObjType = (obj: any) => {
  const toString = Object.prototype.toString
  const map: { [key: string]: string } = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object',
  }
  if (obj instanceof Element) {
    return 'element'
  }
  return map[toString.call(obj)]
}

/**
 * 拼接路由地址和查询参数
 * @param path 路由路径
 * @param query 查询参数对象
 * @returns 拼接后的完整 URL
 */
const generateRouteUrl = (path: string, query: Record<string, any>): string => {
  const queryString = Object.entries(query)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
    )
    .join('&')
  return `${path}?${queryString}`
}

/**
 * 设置页面标题
 */
function setPageTitle(router:any, store:any) {
    const currentPath = router.currentRoute.path;
    const menuMap = store.getters.menuMap;
    const menuName = menuMap[currentPath] || router.currentRoute.name;
    const title = router.$avueRouter.generateTitle(menuName, true);
    // 根据当前的标签也获取 label 的值动态设置浏览器标题
    router.$avueRouter.setTitle(title);
}

export { apiHost, deepClone, generateRouteUrl, getObjType, local, redirect, setPageTitle }


/**
 * 等待直到外部传入的函数返回 true 或超时
 * @param checkFn - 外部定义的判断函数
 * @param interval - 检查间隔时间（默认 100ms）
 * @param timeout - 超时时间（毫秒），默认 10000ms
 * @returns Promise<void>
 */
export async function waitUntil(
  checkFn: () => boolean,
  interval = 100,
  timeout = 100000
): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    const timer = setInterval(() => {
      if (checkFn()) {
        clearInterval(timer);
        clearTimeout(timeoutTimer);
        resolve();
      }
    }, interval);

    const timeoutTimer = setTimeout(() => {
      clearInterval(timer);
      reject(new Error('waitUntil: timeout'));
    }, timeout);
  });
}

export const getStatusConfig = (status: string | number, statusName?: string) => {
  const statusMap: Record<string, string> = {
    '1': 'tag-status-progress',
    '2': 'tag-status-progress',
    '3': 'tag-status-approval',
    '4': 'tag-status-cancelled',
    '5': 'tag-status-not-in-use'
  };
  const statusStr = String(status);

  if (Object.prototype.hasOwnProperty.call(statusMap, statusStr)) {
    return {
      clazz: statusMap[statusStr],
      name: statusName || 'In Progress'
    };
  }
  return {
    clazz: 'tag-status-progress',
    name: 'In Progress'
  };
}

/* 
  统一图标样式
*/
export const iconStyle =  {
  size: "24px",
  color: "#747474"
}

// SmartHint 展示时间配置（本地时间）
export const SMART_HINT_START_AT = '2026-01-19T00:00:00'
export const SMART_HINT_END_AT = '2026-01-19T23:59:59'
/**
 * 判断当前时间是否在 SmartHint 展示时间范围内
 */
export const isSmartHintActive = (now: Date = new Date()): boolean => {
  const start = new Date(SMART_HINT_START_AT)
  const end = new Date(SMART_HINT_END_AT)
  return now >= start && now <= end
}
